import React, { useEffect, useState } from 'react'
import './dataTableStaff.scss'
import { DataGrid } from '@mui/x-data-grid';
import { staffColumns } from '../../data/dataSource';
import { Link } from 'react-router-dom';
import { collection, getDocs,  deleteDoc, doc, onSnapshot, query, orderBy, where } from "firebase/firestore";
import { db } from '../../firebase'
import ConfirmBox from '../ConfirmBox';


const DataTable = () => {

  const [ data, setData ] = useState([])

  
  const [ isLoading, setIsLoading ] = useState(true)

  const [open, setOpen] = useState(false);

  const [deleteId, setDelete] = useState("");



  const Spinner = () => {
    return(
      <div className='spinner-container'>
          <div className='loading-spinner'></div>
      </div>
    )
  }


  useEffect(() => {
 
 //LISTEN REAL TIME
 
     const collectionRef = collection(db, "staff")
     const queryCustomers = query(collectionRef, orderBy("timeStamp", "desc"))
 
     const unsub = onSnapshot(queryCustomers, (snapShot) => {
       let list = [];
       snapShot.docs.forEach((doc) => {
         list.push({ id: doc.id, ...doc.data()})
       })
       setData(list)
       setIsLoading(false)
     }, 
       (error) => {
         console.log(error)
       }
     );
 
     return () => {
       unsub();
     }
 
 //END LISTEN REAL TIME    
 
   },[])

    function openDelete(id) {
      setOpen(true);
      setDelete(id);
    }
  
    console.log(data)
  
    const handleDelete = async() => {
  
      await deleteDoc(doc(db, "staff", deleteId));
        
        setData(data.filter((item) => item.id !== deleteId))
  
        setOpen(false)
  
    }



  const actionColumn = [

    { field: 'action', headerName: 'Action', width: 130, 
    
            renderCell:(params) => {
                return(
                    <div className='cellAction'>
                       <Link to={`/staff/${params.row.id}`} style={{textDecoration:"none"}}>
                          <div className="viewbutton">View</div>
                       </Link>
                       
                      <Link
                        onClick={() => openDelete(params.row.id)}
                        to={"#"}
                        className="deletebutton"
                      >
                          Delete
                      </Link>
                    </div>
                )
            }
    }
      
  ]  

  return (


     <>
    
          <div className="datatable">
          <div className='datatableTitle'>
            All Staff
            <Link to="/staff/new"  style={{textDecoration:"none"}} >
              <div className='link'>
                Add New Staff
              </div>
            </Link>
          </div>
          {isLoading 
          ? <Spinner/>
          :   <DataGrid
                className="staffTableGrid"
                rows={data}
                columns={staffColumns.concat(actionColumn)}
                pageSize={12}
                rowsPerPageOptions={[5]}
                checkboxSelection
              />
            
          }
        </div>
         <ConfirmBox
         open={open}
         closeDialog={() => setOpen(false)}
         // title={deleteData?.name}
         deleteFunction={handleDelete}
         />
        
        </>

  )
}

export default DataTable